export const HEADER_NAME_API_VERSION = 'X-API-VERSION';
export const HEADER_NAME_ORIGINAL_USERID = 'X-AUTH-ORIGINAL-USERID';
